import logoUrl from '../images/logo-96.webp';
import { currentLanguage, t } from './i18n.js';

// The WordPress site. English lives under /en/ (Polylang).
const SITE = 'https://kamilari.org.gr';

/** Top-left mark: the association's logo and name, linking back to the site. */
export function mountBrand(container = document.body) {
	const href = currentLanguage() === 'el' ? `${ SITE }/` : `${ SITE }/${ currentLanguage() }/`;

	const brand = document.createElement( 'a' );
	brand.className = 'km-brand';
	brand.href = href;
	// The tour may be embedded in a WordPress page; leave the frame.
	brand.target = '_top';
	brand.title = t( 'backToSite' );
	brand.innerHTML = `
		<img class="km-brand__logo" src="${ logoUrl }" alt="" width="40" height="40">
		<span class="km-brand__text">
			<strong>${ t( 'name' ) }</strong>
			<small>${ t( 'tour' ) }</small>
		</span>
		<span class="km-brand__back" aria-hidden="true">kamilari.org.gr ↗</span>
	`;

	container.appendChild( brand );
	return brand;
}
